/**
 * Normalizes file extension to lowercase to ensure compatibility with case-sensitive services
 * like Cloudflare Images
 *
 * @param file - The File object to normalize
 * @returns The original file if no changes needed, or a new File object with lowercase extension
 */
export const normalizeFileExtension = (file: File): File => {
  const normalizedName = file.name.replace(/(\.[^.]+)$/, (match) => match.toLowerCase());

  return normalizedName !== file.name
    ? new File([file], normalizedName, { type: file.type })
    : file;
};

/**
 * Normalizes file extensions for an array of files
 *
 * @param files - Array of File objects to normalize
 * @returns Array of File objects with normalized extensions
 */
export const normalizeFileExtensions = (files: File[]): File[] => files.map(normalizeFileExtension);
